import { DeviceTypeParameter } from '../../../@types/model/user';
import { TextField } from '@mui/material';
import React from 'react';
import { DeviceParameter } from '../../../@types/model/device';

export interface DeviceTypeParameterFieldProps {
  parameter: DeviceTypeParameter;
  value: DeviceParameter;
  changeHandler: (value: any) => void;
}

const TextParameterField = (props: DeviceTypeParameterFieldProps) => {
  return (
    <TextField
      fullWidth
      type="text"
      value={props.value.value}
      label={props.parameter.label}
      onChange={(event) => props.changeHandler(event.target.value)}
    />
  );
};
export default TextParameterField;
